import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AddWidgetToPlatform"] */ "/vercel/path0/src/components/addWidgetToPlatform/addWidgetToPlatform.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowToInstallHero"] */ "/vercel/path0/src/components/howToInstallHero/howToInstallHero.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallGuide"] */ "/vercel/path0/src/components/installGuide/installGuide.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetVideoGuide"] */ "/vercel/path0/src/components/widgetVideoGuide/widgetVideoGuide.comp.tsx");
